export default {
  grid: {
    quickLayout: '快捷排版',
    toolbar: {
      select: '选择',
      eraser: '橡皮擦',
      selectAll: '全选',
      clear: '清空',
      reset: '重置',
    },
    board: {
      form: {
        number: {
          label: '行列数',
          row: '行',
          col: '列',
        },
        type: {
          label: '排布形式',
          normal: '行列对齐',
          offset: '列错位',
          offsetY: '行错位',
        },
        background: {
          add: '添加背景',
          label: '单个网格图片',
          name: '统一格子背景',
          edit: '编辑',
          change: '替换',
        },
      },
      boardTips:
        '温馨提示：「网格」重新设计后，请务必进入「元素」界面进行重新排版设计',
      clickTips: '可通过点击/拖拽，选择所需格子',
    },
    chess: {
      name: '消除元素',
      element: {
        title: '元素选用',
        add: '添加元素',
      },
      percent: {
        title: '按权重排版',
        rule: '权重总和需等于100%，请重新配置',
      },
      submit: '应用到棋盘',
    },
    tab: {
      board: '网格',
      chess: '元素',
    },
  },
  dialog: {
    submit: '确认',
    cancel: '取消',
    select: {
      creatived: '请选择已激活的棋盘格子',
      layout: '请在右侧面板中，选需要布局的元素',
    },
  },
}
